module.exports = __webpack_public_path__ + "img/TrialPitExampleRight.ec386ebb.jpg";